export type FQFunction<T> = (value: T) => void

export class FunctionQueue<T> {
  /**
   * Queue of functions to be executed
   */
  private queue: Array<FQFunction<T>> = []

  /**
   * Add the given callback function onto the queue
   * @param cb Callback function to add
   */
  public add(cb: FQFunction<T>): FunctionQueue<T> {
    this.queue.push(cb)

    return this
  }

  /**
   * Call the function queue with a given value
   * @param value Each function in the queue will be called with this value
   */
  public call(value: T) {
    this.queue.forEach(f => f(value))
  }

  /**
   * Remove the given callback function from the queue
   * @param cb Callback function to remove
   */
  public remove(cb: FQFunction<T>): FunctionQueue<T> {
    const index = this.queue.findIndex(fn => fn === cb)

    if (index > -1) {
      this.queue.splice(index, 1)
    }

    return this
  }
}
